module.exports = __webpack_public_path__ + "static/media/Karan Acoustics Phono A Amplifier.ae50dc7a.png";